<div class="card-container h-100" style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden; background: #ffffff;">
  <div class="card-header py-2 px-3 text-white font-weight-bold" style="background: var(--theme-primary, #123c53); font-size: 0.8125rem; text-transform: uppercase; letter-spacing: 0.5px;">
    <i class="fas fa-users mr-1"></i> Family Details
  </div>

  <div class="p-3" *ngIf="!familyData || familyData.length === 0">
    <div class="text-center p-3 bg-light rounded text-muted font-size-12">
      <i class="fas fa-info-circle mr-1"></i> No Family Information Available!
    </div>
  </div>

  <div class="cnt-data p-3" *ngIf="familyData && familyData.length > 0">
    <div class="cont" style="display: flex; flex-direction: column; gap: 0.5rem;">
      <div *ngFor="let item of familyData">
        <div class="p-2.5 rounded border" style="background: #fafbfc; border-color: #e2e8f0 !important;">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <span class="font-weight-bold text-dark" style="font-size: 0.8125rem;">{{ item["Member_Name"] }}</span>
            <span class="badge badge-info px-2 py-1">{{ item["Member_Reletion"] }}</span>
          </div>
          <div class="d-flex justify-content-between text-muted small" style="font-size: 0.75rem;">
            <span><i class="fas fa-briefcase mr-1 text-secondary"></i>{{ item["Member_OccupationType"] }}</span>
            <span *ngIf="item['Member_ContactNumber']"><i class="fas fa-phone mr-1 text-secondary"></i>{{ item["Member_ContactNumber"] }}</span>
            <span *ngIf="item['Member_HowMuchEarn']" class="font-weight-bold text-success">₹{{ item["Member_HowMuchEarn"] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>